export type ImageDimensions = {
  width: number;
  height: number;
};

export function getImageDimensions(file: File): Promise<ImageDimensions> {
  return new Promise((resolve) => {
    if (typeof Image === 'undefined') {
      console.warn('Image constructor is not available in this environment');
      resolve({
        width: 0,
        height: 0,
      });
    }

    const img = new Image();

    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
      });
    };

    img.onerror = (event, source, lineno, colno, error) => {
      console.error('Image load error:', event, source, lineno, colno, error);
      resolve({
        width: 0,
        height: 0,
      });
    };

    img.src = URL.createObjectURL(file);
  });
}
